import { render } from "./MusicSection.vue?vue&type=template&id=bfaf6724"
import script from "./MusicSection.vue?vue&type=script&lang=js"
export * from "./MusicSection.vue?vue&type=script&lang=js"

import exportComponent from "/Users/florianroscher/Sites/simtschuk-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__